<template>
    <div>
        <v-form id="weekdays-component" v-model="validateUserForm">
            <div class="div-spans-title mt-4">
                <span class="span-laboral">{{title}}</span>
                <p>{{subtitle}}</p>
                <div class="div-bottom-line">
                </div>
            </div>
            <v-col cols="12">
                <v-row :class=" $vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'" style="width: 80%;">
                    <v-col :sm="!isEdit ? 3 : 6" :md="!isEdit ? 3 : 6" :lg="!isEdit ? 2 : 3" v-for="(day, index) in weekDays" :key="index">
                        <div class="d-flex flex-row">
                            <div class="d-flex flex-column">
                                <v-checkbox
                                    class="mr-4"
                                    v-model="day.value"
                                    :label="tanslateDayName(day.name)"
                                    color="primary"
                                    hide-details
                                    @click="onChangeWeekDayCheckbox(index, day.value)"
                                >
                                </v-checkbox>
                                <span class="span-hour-wd" v-if="!activeTimePicker && day.value">{{spanHour1}} {{transformHoursToShow(day.workStartHourID)}} - {{transformHoursToShow(day.workEndHourID)}}</span>
                                <span class="span-hour-wd" v-if="activeTimePicker && day.value">{{spanHour1}} {{day.startHour}} - {{day.endHour}}</span>
                                <span class="span-hour-wd" v-if="activeLunchTime && day.value && day.hasLunchTime">{{$t('backoffice.modules-management.planning.form.initials-lunch-time')}} {{transformHoursToShow(day.lunchStartHourID)}} - {{transformHoursToShow(day.lunchEndHourID)}}</span>
                            </div>
                            <span class="mr-2 p-0 circle-span-edit" @click="onEditDays(index)" >
                                <img src="/images/_SVGs/bo/edit_pencil.svg" class="circle" onload="SVGInject(this)" width="12" height="12" />
                            </span>
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-form>

        <base-modal  v-if="!activeTimePicker" v-model="modalEditWeekDay.show" :title="`${$t('backoffice.modules-management.planning.form.labor-hour-of')} ${tanslateDayName(modalEditWeekDay.weekDayNew.name)}`" modal-width="480px" modalAlign="align__flex--center" :persistent="true">
            <template v-slot:modal-body>
                <v-form v-model="modalEditWeekDay.validationWeekDayForm">
                    <v-row class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                        <v-col sm="6">
                            <v-select
                                :label="$t('backoffice.modules-management.planning.form.start-open-hour-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.workStartHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="[startHourRulesForm]"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col sm="6">
                            <v-select
                                ref="refCloseHour"
                                :label="$t('backoffice.modules-management.planning.form.end-close-hour-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.workEndHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="[closeHourRulesForm]"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                        <v-col sm="6">
                            <v-select
                                ref="refLunchStart"
                                :label="$t('backoffice.modules-management.planning.form.start-lunch-time-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.lunchStartHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="modalEditWeekDay.weekDayNew.hasLunchTime ? [startLunchHourRulesForm(modalEditWeekDay.weekDayNew.lunchStartHourID, modalEditWeekDay.weekDayNew.workEndHourID, modalEditWeekDay.weekDayNew.workStartHourID)] : []"
                                :disabled="!modalEditWeekDay.weekDayNew.hasLunchTime"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                        <v-col sm="6">
                            <v-select
                                ref="refLunchEnd"
                                :label="$t('backoffice.modules-management.planning.form.end-lunch-time-required')"
                                filled
                                v-model="modalEditWeekDay.weekDayNew.lunchEndHourID"
                                :items="hourLaborDrops.map(el => ({text: el.hour, value: el.calendarHoursId}))"
                                :rules="modalEditWeekDay.weekDayNew.hasLunchTime ? [endLunchHourRulesForm(modalEditWeekDay.weekDayNew.lunchEndHourID, modalEditWeekDay.weekDayNew.lunchStartHourID, modalEditWeekDay.weekDayNew.workEndHourID, modalEditWeekDay.weekDayNew.workStartHourID)] : []"
                                :disabled="!modalEditWeekDay.weekDayNew.hasLunchTime"
                                :menu-props="{ top: false, offsetY: true }"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-col cols="12" class="pt-0 pl-0">
                        <v-switch v-model="modalEditWeekDay.weekDayNew.hasLunchTime" :label="$t('backoffice.modules-management.planning.form.has-lunch-time')"></v-switch>
                    </v-col>
                </v-form>
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <v-btn style="text-transform: capitalize" class="danger-button" text @click="onCancelEditWeekDay">
                    {{$t('backoffice.actions.cancel')}}
                </v-btn>
                <v-btn :disabled="!modalEditWeekDay.validationWeekDayForm" style="text-transform: capitalize" class="primary-button" text @click="onConfirmWeekDay">
                    {{$t('backoffice.actions.record')}}
                </v-btn>
            </template>
        </base-modal>

        <base-modal v-else v-model="modalEditWeekDayPicker.show" :title="`${$t('backoffice.user-management.form-user.user-create.week-days-component-modal-title')} ${tanslateDayName(modalEditWeekDayPicker.weekDayNew.name)}`" modal-width="480px" modalAlign="align__flex--center" :persistent="true">
            <template v-slot:modal-body>
                <v-form v-model="modalEditWeekDayPicker.validationWeekDayForm">
                    <v-row class="d-flex" :class="$vuetify.breakpoint.xsOnly ? 'flex-column' : 'flex-row'">
                        <v-col sm="6">
                            <v-dialog
                                ref="startHour"
                                v-model="modal1"
                                :return-value.sync="modalEditWeekDayPicker.weekDayNew.startHour"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="modalEditWeekDayPicker.weekDayNew.startHour"
                                    :label="$t('backoffice.user-management.form-user.user-create.week-days-component-start-hour')"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="modal1"
                                    v-model="modalEditWeekDayPicker.weekDayNew.startHour"
                                    full-width
                                    format="24hr"
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="modal1 = false"
                                >
                                    {{$t('backoffice.actions.cancel')}}
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.startHour.save(modalEditWeekDayPicker.weekDayNew.startHour); modal1 = false"
                                >
                                    {{$t('backoffice.actions.record')}}
                                </v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-col>
                        <v-col sm="6">
                            <v-dialog
                                ref="endHour"
                                v-model="modal2"
                                :return-value.sync="modalEditWeekDayPicker.weekDayNew.endHour"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="modalEditWeekDayPicker.weekDayNew.endHour"
                                    :label="$t('backoffice.user-management.form-user.user-create.week-days-component-end-hour')"
                                    prepend-icon="mdi-clock-time-four-outline"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                    v-if="modal2"
                                    v-model="modalEditWeekDayPicker.weekDayNew.endHour"
                                    full-width
                                    format="24hr"
                                >
                                <v-spacer></v-spacer>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="modal2 = false"
                                >
                                    {{$t('backoffice.actions.cancel')}}
                                </v-btn>
                                <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.endHour.save(modalEditWeekDayPicker.weekDayNew.endHour); modal2 = false"
                                >
                                    {{$t('backoffice.actions.record')}}
                                </v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-col>
                    </v-row>
                </v-form>
            </template>

            <template v-slot:modal-actions class="align__flex--center">
                <v-btn style="text-transform: capitalize" class="danger-button" text @click="onCancelEditWeekDay">
                    {{$t('backoffice.actions.cancel')}}
                </v-btn>
                <v-btn :disabled="!modalEditWeekDayPicker.validationWeekDayForm" style="text-transform: capitalize" class="primary-button" text @click="onConfirmWeekDay">
                    {{$t('backoffice.actions.record')}}
                </v-btn>
            </template>
        </base-modal>
    </div>
</template>

<script>

import {GenericServicesGetCalendarHoursDrop} from '@services/GenericServices'
import BaseModal from "@components/shared/widgets/BaseModal.vue";

export default {
    components: {BaseModal},
    props: {
        title: { type: String, default : '', required: true },
        subtitle: { type: String, default : '' },
        weekDays: { type: Array, default() { return [] }, required: true },
        activeLunchTime: { type: Boolean, default: false },
        activeTimePicker: { type: Boolean, default: false },
        spanHour1: { type: String, default: '' },
        spanHour2: { type: String, default: '' },
        isEdit: { type: Boolean, default: false }
    },

    data() {
        return {
            hourLaborDrops: [],
            validateUserForm: false,
            modalEditWeekDay: {
                show: false,
                validationWeekDayForm: false,
                weekDayOld: null,
                weekDayNew: { name: '', value: true, workStartHourID: 1, workEndHourID: 21, lunchStartHourID: 6, lunchEndHourID: 7, isDisabled: false, hasLunchTime: true },
            },
            modalEditWeekDayPicker: {
                show: false,
                validationWeekDayForm: false,
                weekDayOld: null,
                weekDayNew: {
                    name: '',
                    value: true,
                    startHour: null,
                    endHour: null,
                    userLoginHourID: null,
                    isDisabled: false
                }
            },
            modal1: false,
            modal2: false,
        }
    },

    computed: {
        checkRoleId() {
            return this.$store.getters['auth/getState'].roleId;
        },
    },

    methods: {
        tanslateDayName(dayName) {
            switch (dayName) {
                case 'Sunday':
                    return this.$t('backoffice.general.sunday');
                    break;
                case 'Monday':
                    return this.$t('backoffice.general.monday');
                    break;
                case 'Tuesday':
                    return this.$t('backoffice.general.tuesday');
                    break;
                case 'Wednesday':
                    return this.$t('backoffice.general.wednesday');
                    break;
                case 'Thursday':
                    return this.$t('backoffice.general.thursday');
                    break;
                case 'Friday':
                    return this.$t('backoffice.general.friday');
                    break;
                case 'Saturday':
                    return this.$t('backoffice.general.saturday');
                    break;
                default:
                    `${dayName}`;
            }
        },
        transformHoursToShow(hourId) {
            let findHourString = this.hourLaborDrops.filter(e => e.calendarHoursId == hourId);
            if(findHourString && findHourString.length > 0) {
                return findHourString[0].hour;
            } else {
                return ''
            }
        },
        onGetCalendarHours() {
            return GenericServicesGetCalendarHoursDrop()
                .then(response => {
                    this.hourLaborDrops = response.data.result;
                    this.$store.commit('backofficeCalendarHoursDropdown/setCalendarHoursDropdowns', this.hourLaborDrops);
                })
                .catch(error => {
                    console.error('error to get scheduling calendar hours', error);
                })
                .finally(() => {
                })
        },
        onChangeWeekDayCheckbox(index, dayValue) {
            this.$emit('on-change-weekday-checkbox', index, dayValue);
            this.$emit('on-change-validate-form', this.validateUserForm);
        },
        onEditDays(dayIndex) {
            const day = this.weekDays[dayIndex];
            if(this.activeTimePicker) {
                this.modalEditWeekDayPicker.show = true;
                this.modalEditWeekDayPicker.weekDayOld = _.cloneDeep(day);
                this.modalEditWeekDayPicker.weekDayNew = _.cloneDeep(day);
            } else {
                this.modalEditWeekDay.show = true;
                this.modalEditWeekDay.weekDayOld = _.cloneDeep(day);
                this.modalEditWeekDay.weekDayNew = _.cloneDeep(day);
            }
        },
        startHourRulesForm(value) {
            let findOpenHourString = this.hourLaborDrops.find(e => e.calendarHoursId == value);
            let findCloseHourString = this.hourLaborDrops.find(e => e.calendarHoursId == this.modalEditWeekDay.weekDayNew.workEndHourID);
            if(findOpenHourString.hour > findCloseHourString.hour) {
                return 'A hora de entrada deve ser menor que a hora de saída'
            } else {
                return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },
        closeHourRulesForm(value) {
            let stringHourClose = this.hourLaborDrops.filter(e => e.calendarHoursId == value);
            let stringHourOpen = this.hourLaborDrops.filter(e => e.calendarHoursId == this.modalEditWeekDay.weekDayNew.workStartHourID);

            if(this.$refs.refLunchStart) {
                this.$refs.refLunchStart.focus();
                this.$refs.refLunchEnd.focus();

                if(this.$refs.refCloseHour) {
                    this.$refs.refCloseHour.blur();

                    setTimeout(() => {
                        this.$refs.refLunchStart.blur();
                        this.$refs.refLunchEnd.blur();
                    }, 500)
                }

            }

            if(stringHourClose.length > 0 && stringHourOpen.length > 0) {
                const transformClose = this.transformHoursWeekDaysForm(stringHourClose[0].hour);
                const transformOpen = this.transformHoursWeekDaysForm(stringHourOpen[0].hour);

                // First transform hours on date js
                let timeStart = new Date(transformOpen).getHours();
                let timeEnd = new Date(transformClose).getHours();

                //Pick diff hours start
                let hoursDiff = timeEnd - timeStart;
                if(transformClose <= transformOpen) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
                } else if(stringHourClose[0].hour > stringHourOpen.hour) {
                    return this.$t('backoffice.modules-management.planning.form.rules.less-exit-hour')
                } else {
                    return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
                }
            } else {
                return !!value || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },
        startLunchHourRulesForm(lunchStart, close, open) {
            let closeString = this.hourLaborDrops.filter(e => e.calendarHoursId == close);
            let openString = this.hourLaborDrops.filter(e => e.calendarHoursId == open);
            let startLunchString = this.hourLaborDrops.filter(e => e.calendarHoursId == lunchStart);

            if(closeString.length > 0 && openString.length > 0 && startLunchString.length > 0) {

                const transformClose = this.transformHoursWeekDaysForm(closeString[0].hour);
                const transformOpen = this.transformHoursWeekDaysForm(openString[0].hour);
                const startLunchHour = this.transformHoursWeekDaysForm(startLunchString[0].hour);

                if(startLunchHour >= transformClose) {
                    return this.$t('backoffice.modules-management.planning.form.rules.less-close-hour')
                }
                if(startLunchHour <= transformOpen) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
                } else {
                    return !!lunchStart || this.$t('backoffice.modules-management.planning.form.rules.required-field');
                }
            } else {
                return !!lunchStart || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },
        endLunchHourRulesForm(lunchEnd, lunchStart, close, open) {
            let closeString = this.hourLaborDrops.filter(e => e.calendarHoursId == close);
            let openString = this.hourLaborDrops.filter(e => e.calendarHoursId == open);
            let startLunchString = this.hourLaborDrops.filter(e => e.calendarHoursId == lunchStart);
            let endLunchString = this.hourLaborDrops.filter(e => e.calendarHoursId == lunchEnd);

            if(closeString.length > 0 && openString.length > 0 && startLunchString.length > 0 && endLunchString.length > 0) {
                const transformClose = this.transformHoursWeekDaysForm(closeString[0].hour);
                const transformOpen = this.transformHoursWeekDaysForm(openString[0].hour);
                const startLunchHour = this.transformHoursWeekDaysForm(startLunchString[0].hour);
                const endLunchHour = this.transformHoursWeekDaysForm(endLunchString[0].hour, closeString[0].hour, openString[0].hour);

                // First transform hours on date js
                let timeStart = new Date(transformOpen).getHours();
                let timeEnd = new Date(transformClose).getHours();
                let timeEndLunch = new Date(endLunchHour).getHours();

                //Pick diff hours start
                let hoursDiffClose = timeEndLunch - timeEnd;
                let hoursDiffOpen = timeEndLunch - timeStart;

                if(hoursDiffClose >= 0) {
                    return this.$t('backoffice.modules-management.planning.form.rules.less-close-hour')
                }
                if(hoursDiffOpen <= 0) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-entrance-hour')
                }
                if(endLunchHour <= startLunchHour) {
                    return this.$t('backoffice.modules-management.planning.form.rules.higher-lunch-time')
                } else {
                    return !!lunchEnd || this.$t('backoffice.modules-management.planning.form.rules.required-field');
                }
            } else {
                return !!lunchEnd || this.$t('backoffice.modules-management.planning.form.rules.required-field');
            }
        },
        onCancelEditWeekDay() {
            if(this.activeTimePicker) {
                this.modalEditWeekDayPicker.show = false;
                this.modalEditWeekDayPicker.weekDayOld = null;
                this.modalEditWeekDayPicker.weekDayNew = {
                    name: '',
                    value: true,
                    startHour: '',
                    endHour: '',
                    userLoginHourID: null
                };
            } else {
                this.modalEditWeekDay.show = false;
                this.modalEditWeekDay.weekDayOld = null;
                this.modalEditWeekDay.weekDayNew = { name: '', value: true, workStartHourID: 1, workEndHourID: 21, lunchStartHourID: 6, lunchEndHourID: 7, planningUserCalendarHourWeekDayId: null, isDisabled: false, hasLunchTime: true };
            }
        },
        onConfirmWeekDay() {
            if(this.activeTimePicker) {
                this.modalEditWeekDayPicker.show = false;
                let newDay = _.cloneDeep(this.modalEditWeekDayPicker.weekDayNew);
                newDay.value = true;
                newDay.isDisabled = false;
                this.$emit('on-edit-days', newDay);
            } else {
                this.modalEditWeekDay.show = false;
                let newDay = _.cloneDeep(this.modalEditWeekDay.weekDayNew);
                newDay.value = true;
                newDay.isDisabled = false;
                this.$emit('on-edit-days', newDay);
            }
        },
        findHourStringFromId(hourId) {
            let hourString = this.hourLaborDrops.filter(e => e.calendarHoursId == hourId);
            if(hourString && hourString.length > 0) {
                return hourString[0].hour;
            } else {
                return '';
            }
        },
        transformHoursWeekDaysForm(hour) {
            let today = new Date().toISOString();
            today = today.split("T");
            return today[0] + 'T' + hour + ':00' + '.0000';
        },
    },

    mounted() {
        this.onGetCalendarHours();
    }
}
</script>

<style lang="scss" scoped>
@import "@sass/_variables.scss";
#weekdays-component {
    .div-spans-title {
        width: 100%;
            .div-bottom-line {
                border-bottom: 1px solid $grey-border-tab;
                width: 75%;
                border-bottom-width: 1px;
                margin-top: 9px;
                @media(max-width: 501px) {
                    width: 100%;
                }
            }
        .span-laboral {
            margin-bottom: -15px;
            font-size: 18px;
            font-weight: bold;
        }
    }
    .default-garage-hours {
        p, span {
            font-size: 12px;
        }
    }
    .span-hour-wd {
        margin-left: 3px;
        text-align: left;
        font: normal normal normal 10px/15px Lato;
        letter-spacing: 0px;
        color: #9E9D9D;
        opacity: 1;
    }
    .circle-span-edit {
        background-color: #E6E5E5;
        width: 20px;
        height: 0px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
        margin-bottom: 6px;
        margin-top: 22px;
    }
    ::v-deep .v-label {
        margin-top: 5px;
    }
}
</style>
